import { defineComponent, ref, watch, onMounted } from "vue";
import TuiButton from "../Button.vue.mjs";
import SvgIcon from "../SvgIcon.vue.mjs";
import CloseIcon from "../../icons/CloseIcon.vue.mjs";
import useZIndex from "../../../../hooks/useZIndex.mjs";
import { isMobile } from "../../../../utils/environment.mjs";
import ApplyTipsIcon from "../../icons/ApplyTipsIcon.vue.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "index",
  props: {
    message: { default: "" },
    confirm: { type: [Function, null], default: null },
    cancel: { type: [Function, null], default: null },
    confirmButtonText: { default: "" },
    cancelButtonText: { default: "" }
  },
  emits: ["close"],
  setup(__props, { emit }) {
    const props = __props;
    const visible = ref(false);
    const overlayContainerStyle = ref({});
    const { nextZIndex } = useZIndex();
    watch(visible, (val) => {
      if (val) {
        overlayContainerStyle.value = { zIndex: nextZIndex() };
      }
    });
    function handleClose() {
      visible.value = false;
      emit("close");
    }
    function handleAgree() {
      if (props.confirm) {
        props.confirm();
      }
      handleClose();
    }
    function handleReject() {
      if (props.cancel) {
        props.cancel();
      }
      handleClose();
    }
    function onOpen() {
      visible.value = true;
    }
    onMounted(async () => {
      onOpen();
    });
    return { __sfc: true, visible, overlayContainerStyle, nextZIndex, props, emit, handleClose, handleAgree, handleReject, onOpen, TuiButton, SvgIcon, CloseIcon, isMobile, ApplyTipsIcon };
  }
});
export {
  _sfc_main as default
};
